import { render } from "./SingleRow.vue?vue&type=template&id=cd2224a2&scoped=true"
import script from "./SingleRow.vue?vue&type=script&lang=js"
export * from "./SingleRow.vue?vue&type=script&lang=js"

import "./SingleRow.vue?vue&type=style&index=0&id=cd2224a2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd2224a2"]])

export default __exports__